import apiClient from '@/config/api/axios'
import { AUTH_FORGOT_PASSWORD, AUTH_RESET_PASSWORD } from '@/config/api/endpoints'

// Triggers a Supabase recovery email. Always resolves (backend never reveals
// whether the address has an account). `redirectTo` is where the email link lands.
export async function requestPasswordReset(email, redirectTo) {
  const { data } = await apiClient.post(AUTH_FORGOT_PASSWORD, {
    email,
    redirect_to: redirectTo,
  })
  return data
}

// Completes a reset using the recovery access token captured from the email link.
export async function resetPassword(accessToken, password) {
  const { data } = await apiClient.post(AUTH_RESET_PASSWORD, {
    access_token: accessToken,
    password,
  })
  return data
}
